import $ from 'jquery';

/** @typedef {import('../../types').ResponseHandler} ResponseHandler */
/** @typedef {import('../../types').ClientRedirectResponse} ClientRedirectResponse */


/**
 * @type {ResponseHandler}
 * @param {ClientRedirectResponse} response
 */
const handle = response => new Promise(() => {
  $.getScript(response.externalScriptUrl)
    .then(() => {
      const $el = $('<script>');

      $(document.body).append($el);

      $el.html(response.javaScriptRedirect);
    });
});


export default {
  handle,
};



// WEBPACK FOOTER //
// ./src/onePageGiving/hostedPayment/responseHandlers/ClientRedirectResponseHandler.js